module.exports = __webpack_public_path__ + "img/ron_playing_quidditch.6b4c30e0.jpg";